import Share from './Share';

document.addEventListener('DOMContentLoaded', () => {
  const searchElement = document.getElementById('js-share');
  if (searchElement) {
    const search = new Share(searchElement);
    search.mount();
  }
});
